module.exports = __webpack_public_path__ + "img/img-parts-name02.16acf4d5.png";